var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"contain-inside"},[_c('QuestionTextInputSingleOption',{staticClass:"mt-8",attrs:{"item":_vm.question_asked},on:{"selected":_vm.answer_selected}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }